import React from 'react'

const Groups = ({user1, grupo, selectGroup,chat, descifrar }) => {
  return (
    <div>Groups</div>
  )
}

export {Groups}